module.exports = __webpack_public_path__ + "public/SiteImages/darkIntro.svg?e730178b";